var _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRaisingHands(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 20.5658,
    x2: 20.5685,
    y1: 35.241,
    y2: 19.2249,
    fill: "#fcea2b",
    stroke: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "hair"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "skin"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fcea2b",
    stroke: "none",
    d: "M57.5727,35.9529l-0.1749-18.6731l0.0001,0.7675c-0.0005-3.5223,6.4973-4.4704,6.498,0.8314l0.0603,6.4345 l0.1146,12.2387L63.939,23.4786c-0.0005-3.1731,5.6525-3.2804,5.6531,0.8117l0.0035,24.3792 c0.0013,8.8056-7.0629,15.8274-15.8685,15.8286S37.782,57.362,37.7808,48.5564c0.0464-3.0717-0.2798-8.2946-0.2808-15.3797 c2.1739-2.1745,5.6522,0.8046,6.8519,3.646l0.0007,4.8897l-0.0033-23.0647c-0.0005-3.6647,6.6298-3.9373,6.6304,0.5772 l-0.0004-2.9215c-0.0006-3.9456,6.4176-5.3212,6.4186,1.7439"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcea2b",
    stroke: "none",
    d: "M13.9751,35.9529L14.15,17.2797l-0.0001,0.7675c0.0005-3.5223-6.4973-4.4704-6.498,0.8314l-0.0603,6.4345 L7.477,37.5517l0.1318-14.0731c0.0005-3.1731-5.6525-3.2804-5.6531,0.8117L1.9522,48.6695 c-0.0013,8.8056,7.0629,15.8274,15.8685,15.8286s15.945-7.1361,15.9463-15.9417c-0.0464-3.0717,0.2798-8.2946,0.2808-15.3797 c-2.1739-2.1745-5.6522,0.8046-6.8519,3.646l-0.0007,4.8897l0.0033-23.0647c0.0005-3.6647-6.6298-3.9373-6.6304,0.5772 l0.0004-2.9215c0.0006-3.9456-6.4176-5.3212-6.4186,1.7439"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "skin-shadow"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M57.5727,35.9529l-0.1749-18.6731l0.0001,0.7675c-0.0005-3.5223,6.4973-4.4704,6.498,0.8314l0.0603,6.4345l0.1146,12.2387 L63.939,23.4786c-0.0005-3.1731,5.6525-3.2804,5.6531,0.8117l0.0035,24.3792c0.0013,8.8056-7.0629,15.8274-15.8685,15.8286 S37.782,57.362,37.7808,48.5564c0.0464-3.0717-0.2798-8.2946-0.2808-15.3797c2.1739-2.1745,5.6522,0.8046,6.8519,3.646 l0.0007,4.8897l-0.0033-23.0647c-0.0005-3.6647,6.6298-3.9373,6.6304,0.5772l-0.0004-2.9215 c-0.0006-3.9456,6.4176-5.3212,6.4186,1.7439 z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.982,
    x2: 50.9793,
    y1: 37.5517,
    y2: 19.2249,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.5658,
    x2: 20.5685,
    y1: 37.5517,
    y2: 19.2249,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M13.9751,35.9529L14.15,17.2797l-0.0001,0.7675c0.0005-3.5223-6.4973-4.4704-6.498,0.8314l-0.0603,6.4345L7.477,37.5517 l0.1318-14.0731c0.0005-3.1731-5.6525-3.2804-5.6531,0.8117L1.9522,48.6695c-0.0013,8.8056,7.0629,15.8274,15.8685,15.8286 s15.945-7.1361,15.9463-15.9417c-0.0464-3.0717,0.2798-8.2946,0.2808-15.3797c-2.1739-2.1745-5.6522,0.8046-6.8519,3.646 l-0.0007,4.8897l0.0033-23.0647c0.0005-3.6647-6.6298-3.9373-6.6304,0.5772l0.0004-2.9215 c0.0006-3.9456-6.4176-5.3212-6.4186,1.7439 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaisingHands);
export default __webpack_public_path__ + "static/media/Raising_Hands.ce9d2cdb666ab259574bd022f7ffb7a5.svg";
export { ForwardRef as ReactComponent };